export default {
    discoverlogo: 'Discover Card logo',
    monerisVaultLogo: 'MonerisVault Card logo',
    monerisTokenLogo: 'MonerisToken Card logo',
    creditCardLogo: 'Credit Card logo',
    jcbLogo: 'JCB Card logo',
    unionPayLogo: 'UnionPay Card logo',
    searsLogo: 'Sears Card logo',
}